import { hexToRgb } from './hex-to-rgb.function';

export const textColor = (backgroundColor: string | undefined | null) => {
  if (!backgroundColor) return 'text-black';
  const [r, g, b] = hexToRgb(backgroundColor);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 125 ? 'text-black' : 'text-white';
};
